import {
  loadConversationList,
  loadLastActiveConversationId,
  loadMessages,
} from "./chat/persistence";
import type { ConversationMeta } from "./chat/types";

export function generateSessionId(): string {
  return `session-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

export function listSavedConversations(): ConversationMeta[] {
  return loadConversationList();
}

export function resolveInitialSessionId(): string {
  const lastActive = loadLastActiveConversationId();
  const conversations = loadConversationList();
  if (lastActive) {
    const lastActiveStillExists = conversations.some(
      (conversation) => conversation.id === lastActive,
    );
    if (lastActiveStillExists || loadMessages(lastActive).length > 0) {
      return lastActive;
    }
  }
  const firstConversation = conversations[0];
  if (firstConversation?.id) return firstConversation.id;
  return generateSessionId();
}
